import React from 'react';
import classnames from 'classnames';
import DevBudgetChangePercentage from '../Percentage';
import { isValidPercentage, newMathFormatOfDevBudget } from '../../utils';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IBudgetPercentageProps extends IBaseProps {
  budget?: number | string | null;
  budgetChange?: number | null;
}

const BudgetPercentage: React.FC<IBudgetPercentageProps> = (props) => {
  const { style, className, budget, budgetChange } = props;
  const budgetFormatted = newMathFormatOfDevBudget(budget);
  const { isValid: isValidBudgetChange } = isValidPercentage(budgetChange);
  const isNoData = budgetFormatted === '-' && !isValidBudgetChange;

  return (
    <div style={style} className={classnames('dbg-budget-percentage', className)}>
      {isNoData && '-'}
      {isNoData || (
        <>
          <span>{budgetFormatted}</span>
          <DevBudgetChangePercentage value={budgetChange} />
        </>
      )}
    </div>
  );
};

export default BudgetPercentage;
